export default (TARGET) => {
    const togglelist = TARGET === null || TARGET === void 0 ? void 0 : TARGET.closest('ul[data-toggle-list]');
    const allNodes = togglelist.querySelectorAll('.open');
    const currentNode = TARGET === null || TARGET === void 0 ? void 0 : TARGET.closest('li');
    const filteredList = Array.from(allNodes).filter((node) => !node.isEqualNode(currentNode));
    filteredList.forEach((node) => {
        node.classList.remove('open');
    });
    currentNode.classList.toggle('open');
};
